import { useTrend, UseTrendReturn } from './useTrend';
import { getOnTimeTrend, TrendTimeframeGrain } from '../services/completedTrendApi';
import type { AppliedFiltersSnapshot } from '../OnTimeDispatchDashboard';

export type UseOnTimeTrendReturn = UseTrendReturn;

export function useOnTimeTrend(
  appliedFilters: AppliedFiltersSnapshot,
  timeframeGrain: TrendTimeframeGrain
): UseOnTimeTrendReturn {
  return useTrend(getOnTimeTrend, 'On-Time % Trend', appliedFilters, timeframeGrain);
}
